export class TextBuilder {
  fragments: string[] = []
  constructor() {}
  addText(text: string) {
    this._toFragments(text)
    return this
  }
  form(value: number, singular: string, plural: string) {
    this._toFragments(
      value === 1 ? value + ' ' + singular : value + ' ' + plural
    )
    return this
  }
  byProperty(propValue: string | number, options: { [key: string]: string }) {
    this._toFragments(options[propValue.toString()])
    return this
  }
  get() {
    return this.fragments.join('')
  }
  _toFragments(text: string) {
    this.fragments.push(text)
  }
}

export function tb_form(
  value: number,
  singular: string,
  plural: string,
  hideValueOnSingular: boolean = false
) {
  if (hideValueOnSingular) return value === 1 ? singular : value + ' ' + plural
  return value === 1 ? value + ' ' + singular : value + ' ' + plural
}
